import React, { useState } from 'react';
import { style } from 'typestyle';
import CheckIcon from 'mdi-react/CheckCircleIcon';
import type Room from '../models/room/room';
import * as styles from './cards.styles';
import Column from '../../../core/components/column/column.component';
import { MainAxisAlignment, CrossAxisAlignment } from '../../../core/components/flex/flex.component';
import Row from '../../../core/components/row/row.component';

interface Props {
  readonly room: Room;
  readonly checked: boolean;
}

const RoomListCard = ({ room, checked }: Props): React.JSX.Element => {
  const [isChecked, setIsChecked] = useState(checked);

  const onClick = (): void => {
    setIsChecked(!isChecked);
  };

  return (
    <div className={style(styles.infoCard(true))} key={room.name} onClick={onClick} role="presentation">
      <Row mainAxisAlignment={MainAxisAlignment.SpaceBetween} crossAxisAlignment={CrossAxisAlignment.Center}>
        <Column mainAxisAlignment={MainAxisAlignment.SpaceBetween}>
          <span className={style(styles.cardHeader())}>{room.name}</span>
        </Column>
        <CheckIcon className={style(styles.checkIcon(isChecked))} />
      </Row>
    </div>
  );
};

export default RoomListCard;
